import React, { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import Row from '../common/Row';
// eslint-disable-next-line import/no-cycle
import { TableContext } from '../../CustomTable';
import classes from './BodyRow.module.scss';
import colors from '../../../../../../scss/colors';

export default function BodyRow({ row, children }) {
  const ctx = useContext(TableContext);
  const rowClass = [
    !ctx.isApprover && row?.ContractorVisited === false && classes.highlightRow,
    ctx.rowClickHandler && classes.withRowClick
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      role="presentation"
      onClick={() => {
        if (ctx.rowClickHandler) ctx.rowClickHandler(row.Id);
      }}
      onMouseEnter={() => {
        if (ctx.rowFocusInHandler) ctx.rowFocusInHandler(row.Id);
      }}
      onMouseLeave={() => {
        if (ctx.rowFocusOutHandler) ctx.rowFocusOutHandler(row.Id);
      }}
      className={rowClass}
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: !ctx.isApprover && row?.ContractorVisited === false ? colors.HIGHLIGHT : colors.WHITE,
        ...ctx.lineStyles
      }}
    >
      <Row withLines={ctx.withLines?.body}>{children}</Row>
    </div>
  );
}
